import { DIALOG_SCREEN_STATES } from './Config.EJX.js';
import { UIPanel, UIRow } from './libs/ui.js';

function MenubarHelp( editor ) {

	const strings = editor.strings;

	const container = new UIPanel();
	container.setClass( 'menu' );

	const title = new UIPanel();
	title.setClass( 'title' );
	title.setTextContent( strings.getKey( 'menubar/help' ) );
	container.add( title );

	const options = new UIPanel();
	options.setClass( 'options' );
	container.add( options );

	let option = new UIRow();

	// About

	option = new UIRow();
	option.setClass( 'option' );
	option.setTextContent( strings.getKey( 'menubar/help/about' ) );
	option.onClick( function () {

        editor.signals.launchDialog.dispatch( DIALOG_SCREEN_STATES.ABOUT );

	} );
	options.add( option );

	// Manual

	option = new UIRow();
	option.setClass( 'option' );
	option.setTextContent( strings.getKey( 'menubar/help/manual' ) );
	option.onClick( function () {

		window.open( 'https://eyejack.notion.site/EJX-Editor-Intro-for-Creators-5d62bbad3e12490c96d0075e310947ff', '_blank' );

	} );
	options.add( option );

	return container;

}

export { MenubarHelp };
